import { Alert, AlertIcon, Box, Button, ButtonGroup, Center, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Clipboard, Form, Lottie, Modal, Show } from "components";
import { API } from "config";
import { useEffect, useState } from "react";
import { Authenticate } from "screens";

export default function Password({ data:consultant, onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ newPassword, setNewPassword ] = useState()

    const auth = useDisclosure()
    
    const onChange = ({ target }) => {
        const { name, value, checked } = target
        switch(name){
            case 'notify': setForm({...form, [name]: checked}); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const handleSubmit = async () => {
        if(form?.reset_type === 'password'){ resetPassword(); return; }
        if(form?.reset_type === 'security_code'){ resetSecurityCode(); return; }
    }

    const resetPassword = async () => {
        setLoading(true)
        setErrors(null)

        try{
            const callback = await API.put(`/customers/${consultant?.customer?.id}/password`, form)
            setNewPassword(callback.data?.password)
            toast({ title: 'A senha foi redefinida', description: 'Você pode copiar a senha e enviar para o cliente.' })
            setForm({})
            onSuccess()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível redefinir a senha.', description: err?.response?.data?.message })
        }

        setLoading(false)
    }

    const resetSecurityCode = async () => {
        setLoading(true)
        setErrors(null)

        try{
            await API.put(`/customers/${consultant?.customer?.id}/security_code`)
            toast({ title: 'O código se segurança do usuário foi redefinido.' })
            setForm({})
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível redefinir o código de segurança.', description: err?.response?.data?.message })
        }

        setLoading(false)
    }

    useEffect(() => {
        console.log(form)
    }, [form])
    
    return(
    <>
    <Modal loading={loading} {...props}>
        <ModalBody>
            <Lottie animation="password" height={150} options={{ loop: false }} style={{ transform: 'scale(1.8)' }} />

            <Stack spacing={6}>
                <Center>
                    <Text fontSize="lg" children="Redefinir senha do consultor" />
                </Center>

                {!!consultant?.customer?.distributor?.id && (
                    <Alert status="warning" borderRadius="md">
                        <AlertIcon />
                        <Box>
                            <Text fontSize="sm" fontWeight="bold">Este consultor também é responsável por um núcleo</Text>
                            <Text fontSize="xs" mt={1}>
                                Como a conta de acesso é compartilhada com o núcleo <strong>{consultant.customer.distributor.name}</strong>,
                                a nova senha valerá nos dois sistemas — Escritório de Consultor e Escritório de Núcleos.
                            </Text>
                        </Box>
                    </Alert>
                )}

                <Text fontSize="sm">
                    Os consultores possuem dois tipos de senha.
                </Text>

                <Text fontSize="sm">
                    A <strong>Senha de Autenticação</strong> é utilizada para acessar o escritório de consultor. Ao redefinir a senha de autenticação, 
                    é gerada uma nova senha que será exibida aqui e pode ser enviada por e-mail para o consultor. 
                </Text>

                <Text fontSize="sm">
                    O <strong>Código de Segurança (antiga senha financeira)</strong> é utilizada para realizar operações específicas dentro dos escritórios de consultor e de núcleo. 
                    Ao redefinir o código de segurança, o mesmo removido e o próprio consultor irá recadastrá-la pelo escritório.
                </Text>

                <Divider />

                <Show visible={!newPassword}>
                    <Form.Form>

                        <Form.Select
                            label="Qual senha deseja redefinir?"
                            name="reset_type"
                            error={errors?.reset_type}
                            options={[{ label: 'Redefinir Senha de Autenticação', value: 'password' }, { label: 'Redefinir Código de Segurança', value: 'security_code' }]}
                            onChange={onChange}
                            isDisabled={loading}
                            size="lg"
                        />

                        <Show visible={form?.reset_type === 'password'}>
                            <Form.Switch
                                label="Enviar nova senha para o e-mail do consultor"
                                name="notify"
                                isChecked={form?.notify}
                                isDisabled={loading}
                                onChange={onChange}
                            />
                        </Show>

                    </Form.Form>
                </Show>

                {/* Exibe a nova senha de autenticação */}
                <Show visible={!!newPassword}>
                    <Text children="Senha redefinida:" />

                    <Clipboard copy={newPassword}>
                        <Box w="100%" textAlign="center" py={4} bgColor="rgba(0,0,0,0.08)" borderRadius={4}>
                            <Text fontSize="2xl" fontWeight="bold" children={newPassword} />
                        </Box>
                    </Clipboard>

                </Show>

            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button isDisabled={!!newPassword} isLoading={loading} onClick={auth.onOpen} children="Redefinir senha" />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}